if (!window.__cartBundleGuardInit) {
  window.__cartBundleGuardInit = true;

  // Ingredient lines from Build Your Own are permanently $0 (required so
  // each one is its own fulfillment line); the real price lives only in a
  // separate AM/PM Pack fee line. Nothing stops a customer from deleting
  // just the fee line (or never reaching the AM minimum) while keeping the
  // $0 ingredient lines, which would otherwise check out for free. This
  // blocks Checkout — including dynamic express-checkout buttons — whenever
  // that mismatch is present. bundle-builder.js tags fee lines with a
  // hidden `_pack_fee` property specifically so this can detect them.
  const MESSAGE =
    "Your cart has Build Your Own items that aren't part of a complete AM or PM Pack yet. Please finish your pack before checking out.";

  function evaluateCart(cart) {
    let amQty = 0;
    let pmQty = 0;
    let amFee = false;
    let pmFee = false;

    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      // "_Pack" is the current (hidden) key; "Pack" is kept as a fallback
      // for any line already in a cart from before that property was
      // hidden from customers.
      const packLabel = props._Pack || props.Pack;
      if (packLabel === 'AM') amQty += item.quantity;
      if (packLabel === 'PM') pmQty += item.quantity;
      if (props._pack_fee === 'AM') amFee = true;
      if (props._pack_fee === 'PM') pmFee = true;
    });

    return (amQty > 0 && !amFee) || (pmQty > 0 && !pmFee);
  }

  function applyGuard(blocked) {
    document.querySelectorAll('[name="checkout"]').forEach((btn) => {
      btn.disabled = blocked;
      btn.style.opacity = blocked ? '0.5' : '';
      btn.style.cursor = blocked ? 'not-allowed' : '';
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((el) => {
      el.style.display = blocked ? 'none' : '';
    });

    document.querySelectorAll('[data-bundle-guard-message]').forEach((el) => el.remove());

    if (blocked) {
      document.querySelectorAll('[name="checkout"]').forEach((btn) => {
        const note = document.createElement('p');
        note.dataset.bundleGuardMessage = 'true';
        note.textContent = MESSAGE;
        note.style.cssText = 'color:#c0392b;font-size:1.2rem;margin-top:0.8rem;width:100%;';
        btn.insertAdjacentElement('afterend', note);
      });
    }
  }

  async function refresh() {
    try {
      const response = await fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig('json', 'GET'));
      const cart = await response.json();
      applyGuard(evaluateCart(cart));
    } catch (error) {
      /* best-effort */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
}
